import ConversationMessageRecord from "models/view-models/conversations/conversation-message-record";
import {
    ConversationsAction,
    CurrentConversationState,
} from "./conversation-atom.reducer";
import { Thunk } from "utilities/atoms/atom-with-thunks-reducer";
import { sendMessage } from "./send-message.thunk";

interface EditThunkParams {
    content: string;
    messageId: string | undefined;
}

export const edit =
    ({
        content,
        messageId,
    }: EditThunkParams): Thunk<CurrentConversationState, ConversationsAction> =>
    async (dispatch, getState) => {
        if (!content || !messageId) return;

        const childIds = findChildMessageIds(messageId, getState());

        dispatch({ type: "EDIT", ids: Array.from(childIds) });
        sendMessage({ prompt: content, messageId })(dispatch, getState);
    };

function findChildMessageIds(
    messageId: string,
    state: CurrentConversationState,
    childIds: Set<string> = new Set()
) {
    const messages = state.currentConversation?.messages;
    if (!messages) return childIds;

    const byParentId = new Map<string, ConversationMessageRecord>();
    messages.forEach((msg) => {
        if (msg.parentId) {
            byParentId.set(msg.parentId, msg);
        }
    });

    let currentId: string | undefined = messageId;

    while (currentId) {
        const child = byParentId.get(currentId);
        if (!child?.id || childIds.has(child.id)) break;

        childIds.add(child.id);
        currentId = child.id;
    }

    return childIds;
}
